<template>
  <div id="app">
    <CxNavBar />
    <router-view />
    <CxContactUs />
    <button @click="toggleChatBot" class="chatbot-button">?</button>
    <div v-if="showChatBot" class="chatbot-modal" @click="toggleChatBot">
      <div class="chatbot-content" @click.stop>
        <ChatBot />
      </div>
    </div>
  </div>
</template>

<script>
import CxContactUs from "./components/CxContactUs.vue";
import CxNavBar from "./components/CxNavBar.vue";
import ChatBot from "@/components/ChatBot.vue";

export default {
  name: "App",
  components: {
    CxNavBar,
    CxContactUs,
    ChatBot,

},
  data() {
    return {
      showChatBot: false,
    };
  },
  methods: {
    toggleChatBot() {
      this.showChatBot = !this.showChatBot;
    },
  },
};
</script>

<style>
@import "@/css/variables.css";

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  background-color: var(--color-background);
}

main {
  margin: 20px auto;
}

.chatbot-button {
  position: fixed;
  bottom: 10px;
  right: 10px;
  background-color: var(--color-accent);
  border: none;
  border-radius: 50%;
  box-shadow: 0 0 10px var(--color-primary);
  width: 40px;
  height: 40px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  z-index: 1001;
}

.chatbot-button:hover {
  box-shadow: none;
  background-color: var(--color-primary);
  cursor: pointer;
}

.chatbot-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow:auto;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.chatbot-content {
  background-color: var(--color-background);
  opacity: 0.95;
  padding: 20px;
  border-radius: 10px;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}

</style>
